module.exports = __webpack_public_path__ + "static/media/image (34).eafc2d51.jpg";